export default __webpack_public_path__ + "static/biome-simulator-ac416ddc06251522ccf13a0d8b2c9b7c.png";